<div class="tab-data-container">
	<div class="related-request-title">{{ labels.lbl_chamado_filho }}</div>

	@if (!requestData.child_requests || requestData.child_requests.length === 0) {
		<div class="related-requests">
			{{ labels.lbl_geral_sem_artigos_relacionados }}
		</div>
	}
	@for (child_requests of requestData.child_requests; track $index) {
		<div class="related-requests">
			<span class="title p-1">{{ child_requests.id }} > {{ child_requests.summary }}</span>
			<a class="link" target="_blank" [routerLink]="'/request/' + child_requests.id"
				><fa-icon [icon]="icons.faExternalLinkAlt"></fa-icon
			></a>
		</div>
	}
</div>
